import React, { useEffect, useRef, useMemo, useState } from 'react';
import Loading from '../common/Loading';

export default function PlayerBox({ info }) {
  const channelId = info?.channelid;
  const playerRef = useRef(null);
  const [isDevelop, setIsDevelop] = useState(false);

  useEffect(() => {
    // 클라이언트 사이드에서 개발 환경 감지
    if (typeof window !== 'undefined') {
      setIsDevelop(window.location.hostname !== 'www.sbs.co.kr');
    }
  }, []);

  return (
    <div className="live_player_box">
      <div
        className="player_box_video"
        ref={playerRef}
        style={{
          backgroundColor: '#1a1a1a',
          position: 'relative',
          width: '100%',
          paddingTop: '56.25%',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {!info && <Loading />}
          {info && (
            <div
              className="player_video_w"
              style={{ width: '100%', height: '100%' }}
            >
              <sbs-player
                key={channelId}
                target="live"
                media={channelId}
                w="100%"
                h="100%"
                token=""
                mobile
                allow_adblock
                development={isDevelop}
              ></sbs-player>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
